import { Component } from 'react';
import PropTypes from 'prop-types';

// FilterItems is a base component for both FilterPills & FilterRadio
export class FilterItems extends Component {
  handleItemClick = itemId => {
    const { clearFilter, toggleItemId, defaultItem } = this.props;

    if (clearFilter && typeof defaultItem !== 'undefined' && itemId === defaultItem) {
      clearFilter();
    } else {
      toggleItemId(itemId);
    }
  };

  render() {
    const { defaultItem, itemsById, itemIdSelected, children: contentFactory } = this.props;

    const useDefaultItem = Object.keys(itemIdSelected).length === 0 && typeof defaultItem !== 'undefined';

    const items = Object.keys(itemsById).map(itemId => ({
      ...itemsById[itemId],
      id: itemId,
      label: itemsById[itemId].name,
      selected: !!itemIdSelected[itemId] || (useDefaultItem && defaultItem === itemId),
      onClick: this.handleItemClick,
    }));

    return contentFactory(items);
  }
}

FilterItems.propTypes = {
  defaultItem: PropTypes.any,
  itemsById: PropTypes.object.isRequired,
  itemIdSelected: PropTypes.object.isRequired,
  toggleItemId: PropTypes.func.isRequired,
  clearFilter: PropTypes.func,
  children: PropTypes.func,
};
